var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2533 10.3173L9.79672 9.17109C9.58235 9.07156 9.40625 9.18312 9.40625 9.42047V11.5795C9.40625 11.8169 9.58235 11.9284 9.79672 11.8289L12.2522 10.6827C12.4677 10.582 12.4677 10.418 12.2533 10.3173ZM10.5 0C4.70094 0 0 4.70094 0 10.5C0 16.2991 4.70094 21 10.5 21C16.2991 21 21 16.2991 21 10.5C21 4.70094 16.2991 0 10.5 0ZM10.5 14.7656C5.12531 14.7656 5.03125 14.2811 5.03125 10.5C5.03125 6.71891 5.12531 6.23438 10.5 6.23438C15.8747 6.23438 15.9688 6.71891 15.9688 10.5C15.9688 14.2811 15.8747 14.7656 10.5 14.7656Z",
    fill: "#08BD80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic_youtube.0d278d6b41ce6c42901e8adb5f5689a1.svg";
export { ForwardRef as ReactComponent };